import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { OfflinePatientsComponent } from './offline-patients/offline-patients.component';
import { OfflinePatientComponent } from './patient/offline-patient.component';
import { OfflineRoutingModule } from './offline-routing.module';

@NgModule({
  declarations: [
    OfflinePatientsComponent,
    OfflinePatientComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    OfflineRoutingModule
  ]
})
export class OfflineModule { } 